// internal
import { def, handleError } from './internal';

import { addConsole } from './internal';

import { time } from '@goldblack/client-utils';

function AdminCommand(command, args) {
    addConsole(`executing server command '${command}'...`);
    let start = Date.now();

    fetch(`${import.meta.env.VITE_API_BASE_URL || ''}/api/admin_command_sse`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ command, args }),
        credentials: 'include',
    })
        .then(async (response) => {
            if (!response.ok || !response.body) {
                addConsole(`server error: ${response.status}`);
                return;
            }

            const reader = response.body.getReader();
            const decoder = new TextDecoder();
            let buffer = '';

            while (true) {
                const { done, value } = await reader.read();
                if (done) break;

                buffer += decoder.decode(value, { stream: true });

                // SSE events are separated by double newline
                const parts = buffer.split('\n\n');
                buffer = parts.pop(); // keep last incomplete chunk

                for (const part of parts) {
                    const line = part.trim();
                    if (!line.startsWith('data: ')) continue;

                    let data;
                    try {
                        data = JSON.parse(line.slice(6));
                    } catch {
                        continue;
                    }

                    if (data.type === 'log') {
                        addConsole(data.message);
                    } else if (data.type === 'done') {
                        switch (data.code) {
                            case def.ErrorCode.OK:
                                addConsole(`done...${time.printElapsed(start)} elapsed`);
                                break;
                            case def.ErrorCode.ADMIN_UNKNOWN_COMMAND:
                                addConsole(`unknown command: ${command}`);
                                break;
                            case def.ErrorCode.ADMIN_UNKNOWN_COMMAND_ARGS:
                                addConsole(`unknown args: ${args}`);
                                break;
                            case def.ErrorCode.ADMIN_UNKNOWN_CONFIG:
                                addConsole(`unknown config: ${args}`);
                                break;
                            default:
                                addConsole(`error code: ${data.code}`);
                                break;
                        }
                    } else if (data.type === 'error') {
                        addConsole(`error: ${data.message}`);
                    }
                }
            }
        })
        .catch((err) => {
            handleError(err);
        });
}

export { AdminCommand };
